/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Score_AvailableInputs */

const en_no_score_available = /** @type {(inputs: No_Score_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No score available.`)
};

const de_no_score_available = /** @type {(inputs: No_Score_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Score verfügbar.`)
};

/**
* | output |
* | --- |
* | "No score available." |
*
* @param {No_Score_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_score_available = /** @type {((inputs?: No_Score_AvailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Score_AvailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_score_available(inputs)
	return en_no_score_available(inputs)
});